var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconShopSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Icon_-_Shop_-_Selected",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none}.cls-3{fill:#fed148}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2799",
    d: "M0 0H24V24H0z",
    className: "cls-1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Shop_-_Selected-2",
    transform: "translate(-.208 .75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2800",
    d: "M0 0H22V20H0z",
    className: "cls-1",
    transform: "translate(.208 1.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8150",
    fill: "none",
    stroke: "#0baf50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px",
    d: "M1.5 1.5h3.53L7.4 13.317a1.765 1.765 0 0 0 1.76 1.421h8.578a1.765 1.765 0 0 0 1.762-1.421l1.412-7.4h-15",
    transform: "translate(0 .75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8151",
    d: "M16.17 32.085A2.085 2.085 0 1 1 14.085 30a2.085 2.085 0 0 1 2.085 2.085z",
    className: "cls-3",
    transform: "translate(-5.496 -12.924)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8152",
    d: "M16.17 32.085A2.085 2.085 0 1 1 14.085 30a2.085 2.085 0 0 1 2.085 2.085z",
    className: "cls-3",
    transform: "translate(4.233 -12.924)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShopSelected);
export default __webpack_public_path__ + "static/media/icon-shop-selected.8b4dd37075624551040be14320728009.svg";
export { ForwardRef as ReactComponent };